import { useAppSelector } from '../useAppSelector';
import * as lookupSlice from '../../data/lookup.slice';

export const useAlternateContactType = (
  alternateContactBC: string | undefined,
): string => {
  const types = useAppSelector(lookupSlice.selectAlternateContactTypes);
  const type = types.find(
    (s) => s.alternateContactTypeBC === alternateContactBC,
  );
  return type ? type.alternateContactTypeName : '';
};
